import React from 'react';

const XML_EXAMPLE = `<?xml version="1.0" encoding="UTF-8"?>
<recall lang="en" xmlns="urn:recall-schema">
  <edit_type>U</edit_type>
  <id>K18/CP/00039</id>
  <country_id>KR</country_id>
  <manufacturer>N.G.C.T co., Ltd</manufacturer>
  <manufacturer_country_id>MM</manufacturer_country_id>
  <product_type>Children’s Products/Toys</product_type>
  <product_name>Toy (finger paint) 6 updated</product_name>
  <product_desc>Certification number: B363R871-5002</product_desc>
  <product_code>
    <publication>2000-01-01</publication>
    <segment>86000000</segment>
  </product_code>
  <product_model_no>Joan Miro 6 Colors</product_model_no>
  <hazard>Primary aromatic amine content exceeding the standard by 1.2 - 3.3 times&lt;br/&gt; &lt;ul&gt; &lt;li&gt;2-Amino-4-nitro-toluene (5-nitro-o-toluidine) : 12 mg/kg (Standard: below 10 mg/kg)&lt;/li&gt; &lt;li&gt;4-Methyl-m-phenylenediamine (Toluene-2,4-diamine) : 33 mg/kg (Standard: below 10 mg/kg)&lt;/li&gt; &lt;/ul&gt;</hazard>
  <injuries>No injury has been reported.</injuries>
  <action> Exchange&lt;br/&gt;Refund&lt;br/&gt;Repair, etc.</action>
  <URL>http://www.safetykorea.kr/recall/ajax/recallBoard?recallUid=10011389</URL>
  <date>2018-01-30</date>
  <image>
    <filename>Joan Miro 6 Colors-2.jpg</filename>
    <media_type>image/jpeg</media_type>
  </image>
</recall>
`;

const TYPE = `<edit_type>U</edit_type>`;

const Example = () => {
  return (
    <div>
      <h4>Update an existing recall</h4>
      <p className="pt-callout pt-intent-warning pt-icon-info-sign">
        <strong>Important:</strong> When updating a recall, use the command <strong>{TYPE}</strong> in your XML file.
      </p>
      <pre>
        <code className="language-xml">
          {XML_EXAMPLE}
        </code>
      </pre>
    </div>
  )
};

export default Example;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/xml-format/xml-examples/example-modify.js